import { PureComponent } from "react";

import { TitleImgSizeEnum } from "services/custom-section";

import { Link } from "./Link";
import { Container, Description, ImageWrapper, StyledTitle, TextContainer, TitleWrapper, Value } from "./TitleStyles";

const SMALL_IMG_SIZE = 16;
const BIG_IMG_SIZE = 36;
const VALUE_SIZE = 70;
interface IProps {
  description?: string;
  imgSize?: TitleImgSizeEnum;
  imgUrl?: string;
  link?: string;
  title?: string;
  value?: string;
  onLinkClick?(): void;
}

export class Title extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private calculateWidth = () => {
    let dimension = 0;
    if (this.props.value) {
      dimension = VALUE_SIZE;
    }
    if (this.props.imgUrl) {
      dimension = this.props.imgSize === TitleImgSizeEnum.Small ? SMALL_IMG_SIZE : BIG_IMG_SIZE;
    }
    return dimension;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const dimension = this.calculateWidth();
    return (
      <Container>
        {this.props.imgUrl && <img src={this.props.imgUrl} height={dimension} width={dimension} css={ImageWrapper} />}
        <TextContainer imgDimensions={dimension} hasImage={!!this.props.imgUrl}>
          <StyledTitle
            // @ts-expect-error TS(2322)
            description={this.props.description}
            // @ts-expect-error TS(2322)
            value={this.props.value}
            imgSize={this.props.imgSize ? this.props.imgSize : TitleImgSizeEnum.Big}
          >
            {this.props.link ? (
              <Link url={this.props.link} value={this.props.title} inline onClick={this.props.onLinkClick} />
            ) : (
              <TitleWrapper>{this.props.title}</TitleWrapper>
            )}
            <Description> {this.props.description} </Description>
          </StyledTitle>
        </TextContainer>
        {this.props.value && <Value> {this.props.value} </Value>}
      </Container>
    );
  }
}
